require('./editLedger.scss');
const controller = require('./editLedgerCtrl').default;
const template = require('./editLedger.html');

const deps = [
  require('ui/bk/angularMaterial').name,
  require('ui/bk/monthYearSelect').name,
  require('data/model/ledger').name,
  require('data/model/client').name,
  require('data/model/clientSettings').name,
  require('data/collection/fdsConnection').name,
  require('data/collection/ledgerCategory').name,
  require('data/collection/templateLedger').name,
  require('data/collection/currency').name,
  require('data/user').name,
];

module.exports = angular.module('bench.ui.editLedger', deps).component('blEditLedger', {
  bindings: {
    ledgerId: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});
